import { CardComponentProps } from "@~/types/types";
import styles from "./AdditionalMessages.module.scss";

export function AdditionalMessages({
  product,
}: Pick<CardComponentProps, "product">) {
  const messages =
    product.messaging
      ?.filter((m) => m.type === "additional")
      .map((m) => m.title) || [];

  if (messages.length === 0) {
    return null;
  }

  return (
    <div data-testid="additional-messages" data-component="AdditionalMessages">
      {messages.map((message) => (
        <p className={styles.message} key={message}>
          {message}
        </p>
      ))}
    </div>
  );
}
